import { render, staticRenderFns } from "./SunderlandCity.vue?vue&type=template&id=fd92f042&scoped=true&"
import script from "./SunderlandCity.vue?vue&type=script&lang=js&"
export * from "./SunderlandCity.vue?vue&type=script&lang=js&"
import style0 from "./SunderlandCity.vue?vue&type=style&index=0&id=fd92f042&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd92f042",
  null
  
)

export default component.exports